// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1hQIN","head":"Table_head__1HjaQ","col":"Table_col__1aUV6"};